<template>
  <div class="ppcImageInfo"
    v-if="creative && (accountView || (!accountView && (creative.status == 'live' || creative.status == 'done' || creative.status == 'rejected')))">
    <!-- MODAL - delete creative -->

    <md-dialog :md-active.sync="showDialog" v-if="creativeToBeDeleted" @md-clicked-outside="onCancel">
      <md-dialog-title>
        <span>Delete Version</span>
        <button class="btn btn--close" @click="onCancel"></button>
      </md-dialog-title>
      <div class="confirm__content">
        <div v-if="!creative.comment || creative.comment == []" class="text">Are you sure you want to delete the next:
        </div>
        <div v-else class="text">This version cannot be deleted because there are already comments:</div>
        <div><span class="client-name">{{ creative.thumb.file_name_original }}</span></div>
      </div>
      <md-dialog-actions>
        <div class="md-layout">
          <div class="md-layout-item">
            <md-button class="md-primary modal-cancel-btn" @click="onCancel">Cancel</md-button>
          </div>
          <div class="md-layout-item text-right">
            <md-button v-if="!creative.comment || creative.comment == []" class="md-primary modal-delete-btn"
              @click="deleteCreative(creativeToBeDeleted); creativeToBeDeleted = undefined;">Delete</md-button>
          </div>
        </div>
      </md-dialog-actions>
    </md-dialog>

    <div class="imageInfoContainer firstPart">
      <div class="imageInfo">
        <div class="status">
          <span class="imageName">{{ creative.thumb.file_name_original }}</span>
          <span class="imageSize">{{ creative.width }}x{{ creative.height }}</span>
          <div class="statusButton" :class="{
            statusButtonOnClient: status === 'ONCLIENT',
            statusButtonInProgress: status === 'ONAGENCY',
            statusButtonReadyToSend: status === 'READYTOSEND',
            statusButtonApproved: status === 'APPROVED',
            statusButtonRejected: status === 'REJECTED'
          }">
            {{ statusText }}
          </div>
          <div v-if="accountView" class="margin-left-auto">
            <button v-if="!copyLinkAnim" class="copy-creative-link client-copy-link-color  " @click="copyLink()">
              <img alt="Edit Button" src="@/assets/img/icons/clone.svg"> Copy link
            </button>
            <div v-else class="animCopyLink client-copy-link-color copy-creative-link">
              <div><img src="@/assets/img/icons/ic-blue-check.svg"></div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="imageInfoContainer secondPart">
      <div class="imageInfoButtonContainer">
        <!-- Version stepper -->
        <div class="flex-row">
          <Keypress key-event="keydown" :key-code="37" @success="selectCreativeByParentId(creative.id)"
            :preventDefault="true" />
          <Keypress key-event="keydown" :key-code="39" @success="selectCreativeById(creative.parent_id)"
            :preventDefault="true" />
          <button type="button" class="icon-btn icon-btn--left-arrow icon-btn--grey-border"
            :class="{ 'inactive': parseInt(creative.version) === 0 }" @click="selectCreativeByParentId(creative.id)">
          </button>
          <span class="versionText" :class="{ 'red-version-button': parseInt(creative.version) === 2 }">Version {{
            parseInt(creative.version) + 1 }}</span>
          <button type="button" class="icon-btn icon-btn--right-arrow icon-btn--grey-border"
            @click="selectCreativeById(creative.parent_id)" :class="{ 'inactive': !parseInt(creative.parent_id) }">
          </button>
        </div>
        <!-- DEL, COPY btns -->
        <div class="margin-left-auto flex-row">
          <button type="button" @click="creativeToBeDeleted = creative.id; showDialog = true" v-if="accountView"
            class="icon-btn icon-btn--del" title="Delete"></button>
          <a :href="CONFIG.uploadURL + creative.thumb.path + creative.thumb.file_name" target="_blank"
            class="icon-btn icon-btn--copy-link" title="open full size">
          </a>

          <a href="#" class="icon-btn icon-btn--download" title="download" @click="DownloadCreative()">
          </a>
          <button
            v-if="!accountView && creative.comment_status == 'client'&& creative.status != 'done' && creative.status != 'rejected' && creative.parent_id == 0"
            class="btn btn--red btn--reject" @click="rejectDialog = true; showRejectDialog = true">reject</button>
          <!-- REJECT BTN -->
          <button
            v-if="!accountView && creative.status != 'done' && creative.comment_status == 'client' && creative.status != 'rejected' && creative.parent_id == 0"
            class="btn btn-green sendToClientButton editing-buttons" @click="approveCreative">Approve design
          </button>
          <button
            v-if="!accountView && creative.status == 'done' && creative.status != 'rejected' && creative.parent_id == 0"
            class="btn btn--red sendToClientButton editing-buttons" @click="deApproveCreative">withdrawal of approve
          </button>
          <addVersion :board="this.board"
            v-if="accountView && creative.comment_status == 'account' && (creative.status == 'live' || creative.status == 'draft')"
            :creative="creative" />

        </div>
      </div>
    </div>

    <div v-if="$store.state.drawingMode" class="drawingToolBar">
      <div class="colorChooser red" :class="{ 'active': drawingColor == '#f00' }" @click="chooseColor('#f00')"></div>
      <div class="colorChooser black" :class="{ 'active': drawingColor == '#000' }" @click="chooseColor('#000')"></div>
      <div class="colorChooser white" :class="{ 'active': drawingColor == '#fff' }" @click="chooseColor('#fff')"></div>
      <div class="separator"></div>
      <!--<div class="drawing_button eraseer" :class="{'active': erase == true}" @click="erase = !erase">
        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.21875 12.875C7.19141 12.875 7.16406 12.875 7.16406 12.875H4.18359C3.66406 12.875 3.17188 12.6836 2.81641 12.3008L0.847656 10.332C0.0546875 9.56641 0.0546875 8.33594 0.847656 7.57031L6.91797 1.5C7.68359 0.707031 8.91406 0.707031 9.67969 1.5L13.125 4.94531C13.918 5.71094 13.918 6.94141 13.125 7.70703L9.26953 11.5625H13.3438C13.6992 11.5625 14 11.8633 14 12.2188C14 12.6016 13.6992 12.875 13.3438 12.875H7.21875ZM1.75 9.40234L3.71875 11.3711C3.85547 11.5078 4.01953 11.5625 4.18359 11.5625H7.16406C7.32812 11.5625 7.49219 11.5078 7.62891 11.3711L9.40625 9.59375L5.03125 5.21875L1.75 8.47266C1.50391 8.74609 1.50391 9.15625 1.75 9.40234ZM0.847656 7.57031L1.75 8.47266L0.847656 7.57031Z"
            fill="#367CFF" />
        </svg>
      </div>-->
      <div class="drawing_button undo">
        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"
          @click="$refs.VueCanvasDrawing.undo()">
          <path
            d="M1.09375 0.1875C1.44922 0.1875 1.75 0.488281 1.75 0.84375V3.66016C2.81641 1.82812 4.8125 0.652344 7 0.652344C10.3633 0.652344 13.125 3.38672 13.125 6.75C13.125 10.1406 10.3633 12.875 7 12.875C5.55078 12.875 4.15625 12.3828 3.0625 11.4805C2.78906 11.2344 2.76172 10.8242 2.98047 10.5508C3.22656 10.2773 3.63672 10.2227 3.91016 10.4688C4.75781 11.1797 5.85156 11.5625 7 11.5625C9.65234 11.5625 11.8125 9.42969 11.8125 6.75C11.8125 4.09766 9.65234 1.9375 7 1.9375C5.16797 1.9375 3.52734 3.00391 2.70703 4.5625H5.46875C5.82422 4.5625 6.125 4.86328 6.125 5.21875C6.125 5.60156 5.82422 5.875 5.46875 5.875H1.09375C0.710938 5.875 0.4375 5.60156 0.4375 5.21875V0.84375C0.4375 0.488281 0.710938 0.1875 1.09375 0.1875Z"
            fill="#367CFF" />
        </svg>

      </div>
      <div class="drawing_button redo">
        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"
          @click="$refs.VueCanvasDrawing.redo()">
          <path
            d="M13.5625 0.84375V5.21875C13.5625 5.60156 13.2617 5.875 12.9062 5.875H8.53125C8.14844 5.875 7.875 5.60156 7.875 5.21875C7.875 4.86328 8.14844 4.5625 8.53125 4.5625H11.2656C10.4453 3.00391 8.80469 1.9375 7 1.9375C4.32031 1.9375 2.1875 4.09766 2.1875 6.75C2.1875 9.42969 4.32031 11.5625 7 11.5625C8.12109 11.5625 9.21484 11.1797 10.0625 10.4688C10.3359 10.2227 10.7461 10.2773 10.9922 10.5508C11.2109 10.8242 11.1836 11.2344 10.9102 11.4805C9.81641 12.3828 8.42188 12.875 6.97266 12.875C3.60938 12.875 0.875 10.1406 0.875 6.75C0.875 3.38672 3.60938 0.652344 6.97266 0.652344C9.16016 0.652344 11.1562 1.82812 12.25 3.63281V0.84375C12.25 0.488281 12.5234 0.1875 12.9062 0.1875C13.2617 0.1875 13.5625 0.488281 13.5625 0.84375Z"
            fill="#367CFF" />
        </svg>

      </div>
      <div class="drawing_button empty">
        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"
          @click="$refs.VueCanvasDrawing.reset()">
          <path
            d="M5.25 11.6875C5.25 11.9336 5.03125 12.125 4.8125 12.125C4.56641 12.125 4.375 11.9336 4.375 11.6875V6C4.375 5.78125 4.56641 5.5625 4.8125 5.5625C5.03125 5.5625 5.25 5.78125 5.25 6V11.6875ZM7.4375 11.6875C7.4375 11.9336 7.21875 12.125 7 12.125C6.75391 12.125 6.5625 11.9336 6.5625 11.6875V6C6.5625 5.78125 6.75391 5.5625 7 5.5625C7.21875 5.5625 7.4375 5.78125 7.4375 6V11.6875ZM9.625 11.6875C9.625 11.9336 9.40625 12.125 9.1875 12.125C8.94141 12.125 8.75 11.9336 8.75 11.6875V6C8.75 5.78125 8.94141 5.5625 9.1875 5.5625C9.40625 5.5625 9.625 5.78125 9.625 6V11.6875ZM9.54297 1.43359L10.5547 2.9375H12.4688C12.8242 2.9375 13.125 3.23828 13.125 3.59375C13.125 3.97656 12.8242 4.25 12.4688 4.25H12.25V12.5625C12.25 13.793 11.2656 14.75 10.0625 14.75H3.9375C2.70703 14.75 1.75 13.793 1.75 12.5625V4.25H1.53125C1.14844 4.25 0.875 3.97656 0.875 3.59375C0.875 3.23828 1.14844 2.9375 1.53125 2.9375H3.41797L4.42969 1.43359C4.70312 1.02344 5.19531 0.75 5.71484 0.75H8.25781C8.77734 0.75 9.26953 1.02344 9.54297 1.43359ZM5.00391 2.9375H8.96875L8.44922 2.17188C8.42188 2.11719 8.33984 2.0625 8.25781 2.0625H5.71484C5.63281 2.0625 5.55078 2.11719 5.52344 2.17188L5.00391 2.9375ZM3.0625 12.5625C3.0625 13.0547 3.44531 13.4375 3.9375 13.4375H10.0625C10.5273 13.4375 10.9375 13.0547 10.9375 12.5625V4.25H3.0625V12.5625Z"
            fill="#EB5757" />
        </svg>

      </div>
      <div class="separator"></div>
      <button class="btn btn-blue" @click="$store.state.drawingMode = false" ><img alt="Add Button" src="@/assets/img/icons/cancel.svg" class="addButton"> Cancel Drawing</button>
      
    </div>
    <div class="imageInfoBig"  ref="scrollContainer" @mousedown="mouseDown" @mouseleave="mouseUp" @mousemove="scrollImage">
      
      <span ref="imgcont" :class="{ 'invisiblemouse': $store.state.locationMode }"
        style="display: inline-block; position: relative" @mousemove="showPosition" v-on:click="savePosition" @mouseup="mouseUp">
        <img id="creative" :src="CONFIG.uploadURL + creative.thumb.path + creative.thumb.file_name"  
          style="max-width: 100000px" :style="{ 'width': ($parent.scale * creative.width) + 'px' }" />
        <vue-drawing-canvas :image.sync="$store.state.drawingImage" v-if="$store.state.drawingMode" ref="VueCanvasDrawing" :width="creative.width"
          :style="'transform: scale(' + $parent.scale + '); max-width: ' + creative.width + 'px;max-height: ' + creative.height + 'px; transform-origin: top left; background-color: rgba()0,0,0,0) !important;'"
          :height="creative.height" style="position: absolute;  top: 0px; left: 0px;" :color="drawingColor"
          backgroundColor="rgba(0,0,0,0)" strokeType="dash" :eraser="erase" :lineWidth="erase ? 10/$parent.scale : 5/$parent.scale" />
        <!--:backgroundImage="CONFIG.uploadURL + creative.thumb.path + creative.thumb.file_name"-->
        <img v-if="$store.state.locationSearchMode" style="position: absolute;pointer-events: none"
          :style="{ 'left': $store.state.x_position_search * 100 + '%', 'top': $store.state.y_position_search * 100 + '%' }"
          src="@/assets/icons/marker.svg" />
        <img v-if="$store.state.locationMode" style="position: absolute;pointer-events: none"
          :style="{ 'left': $store.state.x_position * 100 + '%', 'top': $store.state.y_position * 100 + '%' }"
          src="@/assets/icons/marker.svg" />
        <img v-if="$store.state.locationViewMode" style="position: absolute;pointer-events: none"
          :style="{ 'left': $store.state.x_position_view * 100 + '%', 'top': $store.state.y_position_view * 100 + '%' }"
          src="@/assets/icons/marker.svg" />
        <img v-if="$store.state.drawViewMode && $store.state.view_comment.comment_attachment && !$store.state.drawingMode"  :src="$store.state.view_comment.comment_attachment[0].data" style="position:absolute; top:0px;left: 0px; max-width: 100000px" :style="{ 'width': ($parent.scale * creative.width) + 'px' }">
      </span> 
      
    </div>


    <!-- REJECT POPUP -->
    <md-dialog :md-active.sync="rejectDialog" class="custom-dialog">
      <md-dialog-title>
        <span>Rejection</span>
        <button class="btn btn--close" @click="rejectDialog = false; showRejectDialog = false"></button>
      </md-dialog-title>
      <div class="text--lead">Are you sure to reject the creative? <br />The agency won’t be able to upload new version.
      </div>
      <md-dialog-actions>
        <div class="md-layout">
          <div class="md-layout-item row">
            <md-button class="md-primary modal-cancel-btn" @click="rejectDialog = false; showRejectDialog = false">
              Cancel
            </md-button>
          </div>
          <div class="md-layout-item text-right">
            <md-button class="md-primary modal-delete-btn" @click="rejectCreative">yes, reject creative</md-button>
          </div>
        </div>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import addVersion from "@/components/pagesComponents/brand/addVersion.vue";
import copyToClipboard from "@/utils/copyToClipboard";
import VueDrawingCanvas from "vue-drawing-canvas";

export default {
 
  components: {
    VueDrawingCanvas,
    Keypress: () => import('vue-keypress'),
    addVersion
  },
  props: ['creative', 'board', 'accountView'],
  data() {
    return {
      drawingscale: 1,
      image: "",
      erase: false,
      drawingColor: '#f00',
      showDialog: false,
      creativeToBeDeleted: undefined,
      copyLinkAnim: false,
      rejectDialog: false,
      showRejectDialog: false,
    }
  },
 
  computed: {
    status() {
      if (this.creative.status == 'draft') {
        return 'READYTOSEND'
      }
      if (this.creative.status == 'rejected') {
        return 'REJECTED'
      }
      if (this.creative.status == 'live') {
        if (this.creative.comment_status == 'account')
          return 'ONAGENCY';
        if (this.creative.comment_status == 'need_more_info')
          return 'ONAGENCY';
        if (this.creative.comment_status == 'client')
          return 'ONCLIENT';
        if (this.creative.comment_status == 'done')
          return 'ONAGENCY';
      }
      if (this.creative.status == 'done') {
        return 'APPROVED'
      }
      if (this.creative.status == 'done') {
        return 'REJECTED'
      }
      return '';
    },
    statusText() {
      if (this.creative.status == 'draft') {
        return 'READY TO SEND'
      }
      if (this.creative.status == 'rejected') {
        return 'REJECTED'
      }
      if (this.creative.status == 'live') {
        if (this.creative.comment_status == 'account')
          return 'ON AGENCY';
        if (this.creative.comment_status == 'need_more_info')
          return 'ON AGENCY';
        if (this.creative.comment_status == 'client')
          return 'ON CLIENT';
        if (this.creative.comment_status == 'done')
          return 'ON AGENCY';
      }
      if (this.creative.status == 'done') {
        return 'APPROVED'
      }
      return '';
    }
  },
  methods: {
    mouseDown(e){
     
      this.$store.state.drag = {
        top: this.$refs.scrollContainer.scrollTop,
        left: this.$refs.scrollContainer.scrollLeft,
        mouseX: e.pageX,
        mouseY: e.pageY
      }
     
    },
    mouseUp(){
      this.$store.state.drag = false;
     
    },
    scrollImage(e){
      if (this.$store.state.drag && !this.$store.state.drawingMode){
       
        this.$refs.scrollContainer.scrollTop = this.$store.state.drag.top - (e.pageY -  this.$store.state.drag.mouseY);
        this.$refs.scrollContainer.scrollLeft = this.$store.state.drag.left - (e.pageX -  this.$store.state.drag.mouseX);
      }
    },
    chooseColor(color) {
      this.erase = false;
      this.drawingColor = color;
    },
    DownloadCreative() {
      if (this.creative.type == 'pdf') {
        var _this = this;
        this.get('documents/' + this.creative.creative_file, {}, function (resp) {
          _this.forceDownload(_this.CONFIG.uploadURL + resp.data.documents[0].path + resp.data.documents[0].file_name, resp.data.documents[0].file_name_original)
        });
      }
      else {
        this.forceDownload(this.CONFIG.uploadURL + this.creative.thumb.path + this.creative.thumb.file_name, this.creative.thumb.file_name_original)
      }
    },
    deleteCreative(id) {
      const _this = this;
      var child = undefined;
      if (this.creative.child) {
        child = this.creative.child;

      }
      this.delete(`creative/${id}`, {}, () => {
        if (child != undefined) { child.parent_id = 0; }
        
        if (child != undefined) {
          _this.put('creative/' + child.id, { board_id: child.board_id, parent_id: 0 }, {}, () => {
            _this.refreshBoard(false).then(() => {
             

              _this.selectCreativeById(child.id)
            })
          })
        }
        _this.refreshBoard(false)

      }, () => {
        console.log('Sikertelen Torles');
      });
    },
    copyLink() {
      const baseUrl = window.location.origin;
      copyToClipboard(baseUrl + '/board/' + this.board.slug);
      // alert('Link was copied')
      this.copyLinkAnim = true
      let _this = this
      setTimeout(() => {
        _this.copyLinkAnim = false
      }, 2000);
    },
    selectCreativeByParentId(parent_id) {
      if (this.$parent.selectCreativeByParentId)
        this.$parent.selectCreativeByParentId(parent_id);
    },
    selectCreativeById(id) {
      if (this.$parent.selectCreativeById)
        this.$parent.selectCreativeById(id);
    },
    showPosition(e) {
      if (this.$store.state.locationSearchMode && e.target.id == 'creative') {
        //console.log(this.$refs.imgcont.clientWidth);
        this.$store.state.x_position_search = e.offsetX / this.$refs.imgcont.clientWidth;
        this.$store.state.y_position_search = e.offsetY / this.$refs.imgcont.clientHeight;

      }
    },
    savePosition(e) {
      console.log('clicked', e)
      if (this.$store.state.locationMode) {
        //console.log(this.$refs.imgcont.clientWidth);
        this.$store.state.x_position = e.offsetX / this.$refs.imgcont.clientWidth;
        this.$store.state.y_position = e.offsetY / this.$refs.imgcont.clientHeight;
        this.$store.state.locationSearchMode = false;
      }
    },

    approveCreative() {
      var _this = this;
      _this.put('creative/' + this.creative.id, { status: 'done', board_id: this.board.id, 'comment_status': 'done' }, {}, function () {
        if (_this.$parent.refreshBoard)
          _this.$parent.refreshBoard()
      })
    },
    deApproveCreative() {
      var _this = this;
      _this.put('creative/' + this.creative.id, { status: 'live', board_id: this.board.id, 'comment_status': 'client' }, {}, function () {
        if (_this.$parent.refreshBoard)
          _this.$parent.refreshBoard()

      })
    },
    rejectCreative() {
      var _this = this;
      _this.put('creative/' + this.creative.id, { status: 'rejected', board_id: this.board.id, 'comment_status': 'done' }, {}, function () {
        if (_this.$parent.refreshBoard)
          _this.$parent.refreshBoard()
        _this.rejectDialog = false;
        _this.showRejectDialog = false
      })
    },
    refreshBrand() {
      if (this.$parent.refreshBrand)
        this.$parent.refreshBrand()
    },
    async refreshBoard(needreselect) {
      return new Promise(resolve => {
        if (this.$parent.refreshBoard)
          this.$parent.refreshBoard(needreselect).then(() => resolve())
      })
    },
    onCancel() {
      this.showDialog = false
      this.creativeToBeDeleted = undefined
    },
  }
}
</script>